import { render, staticRenderFns } from "./reportchange_total.vue?vue&type=template&id=484ef237&scoped=true&"
import script from "./reportchange_total.vue?vue&type=script&lang=js&"
export * from "./reportchange_total.vue?vue&type=script&lang=js&"
import style0 from "./reportchange_total.vue?vue&type=style&index=0&id=484ef237&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ef237",
  null
  
)

export default component.exports